import { type FaqItem, buildFaqList } from "./faq";

const sangjoFaqData: FaqItem[] = [
  {
    question:
      "[임종시 행동요령] 임종하신 상황에서 무엇부터 해야하는지(장례식장 이송 절차, 전체 장례 비용 등) 빠르게 알고싶어요.",
    answer:
      "1. 빈소 확인 및 할인: 고이장례연구소에서는 전국의 장례식장 빈소 상황을 빠르게 확인하여 전화로 안내드려요. 2. 이송조치 및 서류 안내: 1666-9784로 연락주시면, 고이장례연구소에서 앰뷸런스 배차와 장례시 필요 서류를 즉시 안내해드리고 있어요. 3. 온라인 사전 견적: e하늘 장사 정보 시스템의 정보를 기반으로 고이장례연구소에서 자체 산정한 사전 견적을 통해 전체 장례 비용을 미리 확인하실 수 있어요. <a href='https://www.goifuneral.co.kr/match/request/?utm_campaign=naver_faq_dogsound'>전체 장례 비용 알아보기 - 고이장례연구소</a>",
  },
];

export const sangjoFaqRichSearch = buildFaqList(sangjoFaqData);
